import * as Sentry from '@sentry/react'

import { conversionGoalsResponseSchema } from './schemas'

// Same lenient-parse-with-Sentry-capture convention as
// domain/integrationAssets/mappers.js's mapIntegrationDetails — fall through
// to the raw response on schema mismatch rather than breaking the selector.
export function mapConversionGoalsResponse(data) {
  const parsed = conversionGoalsResponseSchema.safeParse(data)
  if (!parsed.success) {
    Sentry.captureException(parsed.error)
  }
  const source = parsed.success ? parsed.data : data ?? {}

  return {
    conversionTracking: source.conversion_tracking ?? null,
    selectionMode: source.selection_mode ?? null,
    goals: source.goals ?? [],
    warnings: source.warnings ?? [],
    meta: source.meta ?? {},
  }
}
